// import Vue from 'vue'
// import VueRouter from 'vue-router'

// Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [{
        path: '/',
        redirect: {
            name: "broadcast"
        }
    },
    {
        path: '/broadcast',
        name: 'broadcast',
        component: () =>
            import ('@/components/information/broadcast.vue'),
    },
    {
        path: '/project',
        name: 'project',
        component: () =>
            import ('@/components/information/project.vue'),
    },
    {
        path: '/financing',
        name: 'financing',
        component: () =>
            import ('@/components/information/financing.vue'),
    },
    {
        path: '/report',
        name: 'report',
        component: () =>
            import ('@/components/research/report.vue'),
    },
    {
        path: '/comments',
        name: 'comments',
        component: () =>
            import ('@/components/research/comments.vue'),
    },
    {
        path: '/exposure',
        name: 'exposure',
        component: () =>
            import ('@/components/complaints/exposure.vue'),
    },
    {
        path: '/complainList',
        name: 'complainList',
        component: () =>
            import ('@/components/complaints/complainList.vue'),
    },
    {
        path: '/rating',
        name: 'rating',
        component: () =>
            import ('@/components/complaints/rating.vue'),
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

export default router